export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 250;
export const SIDE_NAV_COLLAPSED_WIDTH = 80;
export const HEADER_HEIGHT = 70;
export const FOOTER_HEIGHT = 60;
export const TOP_NAV_HEIGHT = 55;
export const SIDE_NAV_LIGHT = 'SIDE_NAV_LIGHT';
export const SIDE_NAV_DARK = 'SIDE_NAV_DARK';
export const NAV_TYPE_SIDE = 'SIDE';
export const NAV_TYPE_TOP = 'TOP';
export const DIR_LTR = 'ltr';
export const DIR_RTL = 'rtl';
export const CONTENT_MAX_WIDTH = 1400;
export const CONTENT_HEIGHT_OFFSET = HEADER_HEIGHT + FOOTER_HEIGHT;
export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#FBFBF8';
export const HEADER_BG_DEFAULT_COLOR_DARK = '#1A2127';
export const LAYOUT_CONTENT_GUTTER = 28;
export const LAYOUT_CONTENT_GUTTER_SM = 16;
export const SIDE_NAV_DARK_BG_COLOR = '#151B20'

/* ---------------------------------------------------------------------------
 * Joyillula — brand palette, sampled from the client logo (JI summit mark)
 *   Charcoal primary (mountain) · warm sand surfaces · signal orange accent (arc) · ink text
 * Constant names (EVERGREEN/OCHRE) are kept for template compatibility; values are re-pointed.
 * ------------------------------------------------------------------------- */
export const EVERGREEN = '#2A353F';          // "charcoal" — from the logo's mountain
export const EVERGREEN_DEEP = '#1B232B';
export const EVERGREEN_SOFT = '#E7E9EB';
export const OCHRE = '#F0932E';              // "orange" — from the logo's arc
export const OCHRE_SOFT = '#FCEBD7';
export const SAND = '#F6F4EE';
export const PARCHMENT = '#FBFBF8';
export const INK = '#191E22';

export const CHARCOAL = EVERGREEN;
export const CHARCOAL_DEEP = EVERGREEN_DEEP;
export const CHARCOAL_SOFT = EVERGREEN_SOFT;
export const ORANGE = OCHRE;
export const ORANGE_SOFT = OCHRE_SOFT;

export const BLUE_BASE = EVERGREEN;          // primary
export const PURPLE_BASE = '#6C7BD1';
export const CYAN_BASE = '#2F9E44';          // success
export const GREEN_BASE = '#2F9E44';
export const MAGENTA_BASE = '#B5477E';
export const PINK_BASE = '#B5477E';
export const RED_BASE = '#C0392B';           // error
export const ORANGE_BASE = OCHRE;
export const YELLOW_BASE = '#E8B84B';
export const VOLCANO_BASE = '#C0392B';       // error
export const GEEK_BLUE_BASE = '#3E7CA6';     // info
export const LIME_BASE = '#7FB03A';
export const GOLD_BASE = OCHRE;              // warning / accent

export const WHITE = '#ffffff';
export const DARK = '#000000';
export const GRAY_DARK = INK;                // headings
export const GRAY = '#3D4A44';               // body text
export const GRAY_LIGHT = '#7A867F';         // muted / captions
export const GRAY_LIGHTER = '#E4E7E1';
export const GRAY_LIGHTEST = '#F2F3EE';

export const BODY_BACKGROUND = SAND;

export const FONT_SIZE_BASE = 14;

export const FONT_DISPLAY = `'Bricolage Grotesque', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`;
export const FONT_BODY = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;
export const FONT_MONO = `'IBM Plex Mono', ui-monospace, SFMono-Regular, 'SF Mono', Menlo, monospace`;

export const TEMPLATE = {
    HEADER_HEIGHT,
    FOOTER_HEIGHT,
    TOP_NAV_HEIGHT,
    CONTENT_HEIGHT_OFFSET,
    SIDE_NAV_WIDTH,
    SIDE_NAV_COLLAPSED_WIDTH,
    SIDE_NAV_DARK_BG_COLOR,
    CONTENT_MAX_WIDTH,
    HEADER_BG_DEFAULT_COLOR_LIGHT,
    HEADER_BG_DEFAULT_COLOR_DARK,
    LAYOUT_CONTENT_GUTTER,
    LAYOUT_CONTENT_GUTTER_SM,
    NAV_TYPE_SIDE,
    NAV_TYPE_TOP,
    SIDE_NAV_LIGHT,
    SIDE_NAV_DARK,
    DIR_LTR,
    DIR_RTL
}

export const THEME_COLOR = {
    BLUE: BLUE_BASE,
    PURPLE: PURPLE_BASE,
    CYAN: CYAN_BASE,
    GREEN: GREEN_BASE,
    MAGENTA: MAGENTA_BASE,
    PINK: PINK_BASE,
    RED: RED_BASE,
    ORANGE: ORANGE_BASE,
    YELLOW: YELLOW_BASE,
    VOLCANO: VOLCANO_BASE,
    GEEK_BLUE: GEEK_BLUE_BASE,
    LIME: LIME_BASE,
    GOLD: GOLD_BASE,
}

export const FONT_WEIGHT = {
    LIGHTER: 'lighter',
    LIGHT: 300,
    NORMAL: 400,
    SEMIBOLD: 500,
    BOLD: 'bold',
    BASE: 400,
    BOLDER: 'bolder'
}

export const FONT_SIZES = {
    BASE: FONT_SIZE_BASE,
    LG: FONT_SIZE_BASE + 2,
    SM: 12
}

export const SPACER = {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '3rem',
}

const BREAKPOINT = {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1400px',
    xxl: '1600px'
}

export const MEDIA_QUERIES = {
    DESKTOP: `(min-width: ${BREAKPOINT.xl})`,
    LAPTOP: `(max-width: ${BREAKPOINT.xxl})`,
    LAPTOP_ABOVE: `(min-width: ${BREAKPOINT.xxl})`,
    TABLET: `(max-width: ${BREAKPOINT.lg})`,
    MOBILE: `(max-width: ${BREAKPOINT.md})`,
}

export const BORDER = {
    BASE_COLOR: '#E5E3D8'
}

export const GRAY_SCALE = {
    DARK,
    WHITE,
    GRAY_DARK,
    GRAY,
    GRAY_LIGHT,
    GRAY_LIGHTER,
    GRAY_LIGHTEST
}

export const DARK_MODE =  {
    TEXT_COLOR: '#C3C9CD',
    HEADING_COLOR: '#ECEDEE',
    BG_COLOR: '#1A2127',
    BORDER_BASE_COLOR: '#303A42',
    HOVER_BG_COLOR: '#232B32',
    ACTIVE_BG_COLOR: '#1F262C',
    DROP_DOWN_SHADOW: '0 3px 6px -4px rgb(0 0 0 / 24%), 0 6px 16px 0 rgb(0 0 0 / 40%), 0 9px 28px 8px rgb(0 0 0 / 18%)'
}
